import { crossOriginCommunicationController } from '../../../controllers/crossOriginCommunication/CrossOriginCommunicationControllerConnector';
import { OutgoingMessage } from '../../../controllers/crossOriginCommunication/types';
import { Logger } from '../../../logger/Logger';
import type { CoreStoreType } from '../../../store/CoreStore';
import { type GameCommunicationErrorMessageType, IGameCommunicationProcessor } from '../types';

export enum ThirdPartyErrors {
  RealityCheckError = 101020,
}

export interface ThirdPartyErrorMessage extends GameCommunicationErrorMessageType {
  error: string;
  id: string;
  type: string;
  user_id: string;
  value: string;
}

export class GameCommunicationThirdPartyErrorProcessor implements IGameCommunicationProcessor {
  messageName = 'thirdpartyerror';

  process(message: ThirdPartyErrorMessage, store: CoreStoreType): void {
    const errorCode = message.optExtErrorCode;
    const errorMessage = message.optExtErrorMsg;

    crossOriginCommunicationController.dispatch(OutgoingMessage.ErrorMessage, { errorCode, errorMessage });

    Logger.logFailure(
      'errors',
      'gameCommunicationError',
      'GameCommunicationThirdPartyErrorProcessor',
      Date.now(),
      1,
      `${errorCode}`,
      false
    );
  }
}
